import { render, staticRenderFns } from "./detailsAlert.vue?vue&type=template&id=20753139&"
import script from "./detailsAlert.vue?vue&type=script&lang=js&"
export * from "./detailsAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports